exports.init = function AtualizaInputs() {
  const $descricao = $('#descricao');
  const $descricaoFilhas = $('.js-fluxo-descricao');
  const $condicaoFilho = $('[name^=condicaoFilho]');
  const $condicaoNeto = $('[name^=condicaoNeto]');
  const $etapaObrigatoria = $('[name^=etapaObrigatoria]');

  $descricao.on('change', function descricaoChange() {
    $descricaoFilhas.html(this.value);
  });

  $condicaoFilho.on('change', function condicaoFilhoChange() {
    const value = this.value;
    const name = this.getAttribute('name');
    $('[name="' + name + '"]').each(function() {
      this.value = value;
    });
  });

  $condicaoNeto.on('change', function condicaoNetoChange() {
    const value = this.value;
    const name = this.getAttribute('name');
    $('[name="' + name + '"]').each(function() {
      this.value = value;
    });
  });

  $etapaObrigatoria.on('change', function etapaObrigatoriaChange() {
    const $divCondicao = $(this).parent().find('.js-condicao-etapa');
    $divCondicao.toggleClass('hidden', !!Number(this.value));
  });
};
